module.exports = __webpack_public_path__ + "static/media/cover_ger_7_8.0affc3a8.jpg";